export default __webpack_public_path__ + "static/media/faps.5b753ff3.png";